import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  dotsIconActive: {
    color: theme.palette.secondary.dark
  }
}));
